<template>
<span>
  <ct-button
    class="report-button"
    type="secondary"
    size="mini"
    @click="showReportModal"
  ><ct-icon
  name="info-empty"
  class="report-button-icon"
  ></ct-icon>{{ $t('question.ReportProblems') }}</ct-button>
  <ct-modal
    v-if="visibleModal"
    append-to-body
    width="560px"
    class="report-modal"
    :class="{'report-modal_mobile': isMobile}"
    @closed="closedModal"
    :title="$t('question.ReportProblemsTitle')"
  >
    <div slot="body">
          <ct-radio
            class="option"
            :key="option"
            :label="option"
            v-model="selectedLabel"
            v-for="option in radioOptions"
          >
            <template slot="labelText">
               {{ $t(`question.${option}`) }}
            </template>
          </ct-radio>

        <div v-if="selectedLabel === 'Custom'">
            <h4 class="title">{{ $t('question.FeedbackDesc')}}</h4>
            <div class="input-container">
                <textarea
                    :maxlength="maxlength"
                    v-model="description"
                    :disabled="selectedLabel !== 'Custom'"
                    class="edit-input"
                    :placeholder="$t('question.CustomPlaceholder')"
                    rows="12">
            </textarea>
            </div>
        </div>

        <div class="input-count-tip" v-if="selectedLabel === 'Custom'">
            <span class="input-count-tip--count">{{ count }}</span>
            <span>/{{ maxlength }}</span>
        </div>
    </div>
    <div slot="footer">
      <ct-button
        type="text_secondary_light"
        @click.prevent="closedModal"
        >{{ $t('common.Cancel') }}</ct-button>
      <ct-button
        type="primary"
        :disabled="loading||disabled"
        :isLoading="loading"
        @click.prevent="reportQuestion"
        >{{ $t('common.Submit') }}</ct-button>
    </div>
  </ct-modal>
</span>
</template>
<script>
import api from '@ca/api'
import { VERSION } from '@ca/constants'

export default {
  name: 'ReportError',
  props: {
    questionId: {
      type: Number,
      required: true,
      default: 0
    },
    index: Number,
    navigation: Array
  },
  components: {
  },
  data () {
    return {
      appVersion: VERSION,
      visibleModal: false,
      errorTypes: [
        'Incorrect answer',
        'Unclear or confusing expression',
        'Lacking of picture demonstration',
        'Selection type error',
        'Inappropriate words or spelling mistakes'
      ],
      selectTypes: [],
      description: '',
      maxlength: 500,
      pending: false,
      files: [],
      imgList: [],
      selectedLabel: '',
      radioOptions: ['Unfamiliar', 'NeedToExplain', 'ItTooSimple', 'Custom'],
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    disabled () {
      return !this.selectedLabel || (this.selectedLabel === 'Custom' && (this.count <= 0 || this.count > this.maxlength))
    },
    count () {
      const description = this.description.toString()
      return description.length
    },
    loading () {
      return this.pending
    },
    selectedValue () {
      let value = ''
      for (let key in this.types) {
        if (this.types[key] === this.selectedLabel) {
          value = key
        }
      }
      return value
    }

  },
  watch: {
    selectedLabel () {
      this.description = ''
    }
  },
  methods: {
    closedModal () {
      this.visibleModal = false
    },
    showReportModal () {
      this.visibleModal = true
      this.selectedLabel = ''
      this.description = ''
    },
    feedback (data) {
      return api.feedback({
        data
      }).then(res => {
        if (res.data && res.data.code === 1) {
          this.closedModal()
        } else {
          this.$toast(res.data ? res.data.error : this.$t('common.ErrAgain'))
        }
        this.pending = false
      }, () => {
        this.pending = false
      })
    },
    reportQuestion () {
      this.pending = true
      //   const selectTypes = this.selectTypes.join(',')
      //   const navigation = this.navigation.join('_')
      //   let desc = `题目ID${this.questionId}_${navigation}_第${this.index}题_${selectTypes}_${this.description}`
      const data = {
        desc_type: this.selectedValue,
        app_version: this.appVersion,
        desc: this.description,
        device: window.navigator.userAgent,
        work_id: +this.$route.params.exam_id,
        question_id: this.questionId
      }
      this.feedback(data)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';

.report-button{
  width:120px;
  padding: 0;
  letter-spacing: -0.5px;
  font-size:12px;
  font-family:SFProDisplay-Medium;
  font-weight:500;
  cursor: pointer;
  &-icon{
    margin-right: 8px;
  }
}
$textColor: #A3B1BF;
.report-modal{
  .title{
    margin-bottom: 8px;
  }
  .report-errors-type{
    margin-bottom: 22px;
    line-height: 24px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .add-img{
    padding: 12px 16px;
    margin-bottom: 8px;
    position: relative;
    &-icon{
      margin-right:8px;
    }
  }
  .img-container{
    position: relative;
    display: inline-block;
    margin: 10px 32px 0 0;
    border-radius: 2px;
    border: 1px solid $secondary;
    .remove-icon{
      cursor: pointer;
      position: absolute;
      top: -7px;
      border-radius: 50%;
      right: -7px;
      line-height: 1;
      background: #fff;
    }

  }
}

.edit-input{
  background-color: #fff;
  border-radius:2px;
  font-weight:400;
  color:$secondary;
  width: 100%;
  outline: none;
  resize: vertical;
  padding: 12px;
  font-size: inherit;
  border:1px solid rgba(218,224,229,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.file-input {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  opacity: 0;
  cursor: pointer;
}
.report-modal_mobile /deep/ {
    .ct-modal--box {
        width: 90%!important;
    }
}
</style>
